import React from 'react';
import { Spin, Empty } from 'antd';
import clsx from 'clsx';

import { Block } from '@atoms';

import MediaTile from './Tile';
import Header from './Header';
import { useMediaLibrary } from './hooks';

import s from './styles.module.less';

const MediaTiles = ({ mediaLibrary, variant, selectable = true, onSelect }) => (
  <Spin spinning={mediaLibrary.listQuery.isFetching}>
    <Block>
      {mediaLibrary.dataSource.length > 0 ? (
        <ul className={clsx(s.root, variant === 'small' && s.small)}>
          {mediaLibrary.dataSource.map((media) => (
            <MediaTile
              selectable={selectable}
              key={media.id}
              media={media}
              isSelected={mediaLibrary.selection.isSelected(media)}
              checkbox={mediaLibrary.selection.checkbox}
              onSelect={onSelect}
            />
          ))}
        </ul>
      ) : (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
      )}
    </Block>
  </Spin>
);

MediaTiles.Header = Header;
MediaTiles.useMediaLibrary = useMediaLibrary;

export default MediaTiles;
